import { createPaginator } from "@smithy/core";
import { ChimeSDKMessagingClient } from "../ChimeSDKMessagingClient";
import { ListChannelsModeratedByAppInstanceUserCommand, } from "../commands/ListChannelsModeratedByAppInstanceUserCommand";
export const paginateListChannelsModeratedByAppInstanceUser = createPaginator(ChimeSDKMessagingClient, ListChannelsModeratedByAppInstanceUserCommand, "NextToken", "NextToken", "MaxResults");
